import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SizeTypeList from './SizeType/SizeTypeList'
import SizeValueList from './SizeValue/SizeValueList'

const SizeTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('sizevalue')

  return (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            <Link
              onClick={() => setActiveToggle('sizevalue')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'sizevalue' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Value
                <hr />
              </span>
            </Link>
            <Link
              onClick={() => setActiveToggle('sizetype')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'sizetype' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Type
                <hr />
              </span>
            </Link>
          </div>

          <div className='tab-content p-3'>
            <div
              id='sizevalue'
              className={`tab-pane fade ${
                activeToggle === 'sizevalue' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'sizevalue' && <SizeValueList />}
            </div>
            <div
              id='sizetype'
              className={`tab-pane fade ${
                activeToggle === 'sizetype' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'sizetype' && <SizeTypeList />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SizeTabbing
